import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FwIconComponent, FwPopoverComponent } from '@flywheel-io/vision';

import { LdapSync } from '../../shared/models/ldap.model';

@Component({
  selector: 'app-ldap-indicator',
  standalone: true,
  imports: [MatIconModule, FwIconComponent, FwPopoverComponent, CdkOverlayOrigin, CommonModule],
  templateUrl: './ldap-indicator.component.html',
  styleUrl: './ldap-indicator.component.scss',
})
export class LdapIndicatorComponent {
  ldapStatus = input<LdapSync>();
}
